import { render, staticRenderFns } from "./MyOrganisationSettings.vue?vue&type=template&id=0d18dd84&"
import script from "./MyOrganisationSettings.vue?vue&type=script&lang=js&"
export * from "./MyOrganisationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports